import { TabPanel, TabView } from 'primereact/tabview';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { ScoreCardFilter } from '../../components/scoreCardFilter/ScoreCardFilter';
import { selectCurrentIsAdmin, selectCurrentIsHC, selectCurrentUser } from '../login/authSlice';
import './Admin.scss';
import { Messaging } from '../../components/messaging/messaging';
import { AdminCA } from '../../components/adminCA/AdminCA';

export const Admin = () => {
    const loggedUser = useSelector(selectCurrentUser);
    const [agentNumber, setAgentNumber] = useState<any>();
    const [inputMonth, setMonth] = useState(new Date().getMonth() + 1);
    const [inputYear, setYear] = useState(new Date().getFullYear());
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [inputScorecardVersion, setInputScorecardVersion] = useState(0);
    const [agentName, setAgentName] = useState('');
    const [inputScorecardName, setInputScorecardName] = useState('');
    const [inputScorecardId, setInputScorecardId] = useState<any>();
    const [inputParentClientId, setInputParentClientId] = useState<any>();
    const [hideScFilter, setHideScFilter] = useState<boolean>(true);

    const isHC = useSelector(selectCurrentIsHC);
    const isAdmin = useSelector(selectCurrentIsAdmin);

    const onScoreCardChange = (value: any) => {
        if (value !== undefined && value !== '' && value !== null) {
            setMonth(value.month);
            setYear(value.year);
            setInputScorecardVersion(value.scorecardVersionId);
            setInputScorecardName(value.scorecardName);
        }
    };

    const onAgentNameChange = (e: any) => {
        setAgentName(e);
        console.log(agentName, agentNumber, inputMonth, inputYear, inputScorecardVersion, inputScorecardName,inputScorecardId,inputParentClientId);
    };

    return (
        <div>
            <div className="card shadow bg-body rounded mt-3 border-0">
                <div className="card-body p-3">
                    <div className="row">
                        <div className="col-md-4 text-start">
                            <span id="label_employeename" className="mt-1 ms-3 d-inline-block">
                                {`Hello ${loggedUser}!`}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {!hideScFilter &&(<div className="card shadow bg-body rounded mt-3 border-0">
                <div className="card-body p-3">
                    <div className="row">
                        <ScoreCardFilter
                            menuName={'Admin'}
                            agentNumber={setAgentNumber}
                            scorecardData={onScoreCardChange}
                            agentName={onAgentNameChange}
                            filterSCValue={setInputScorecardVersion}
                            filterMonth={setMonth}
                            filterYear={setYear}
                            scorecardId={setInputScorecardId}
                            parentClientId={setInputParentClientId}
                        />
                    </div>
                </div>
            </div>)}

            <div className="card shadow bg-body rounded mt-4 border-0">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <TabView
                                activeIndex={activeIndex}
                                onTabChange={(e) => {
                                    setActiveIndex(e.index);
                                    setHideScFilter(true);
                                }}
                            >                               
                                {(isAdmin || isHC ) && (
                                     <TabPanel header="Corrective Actions" >
                                     <AdminCA />
                                    </TabPanel>
                                )}
                                
                                {isAdmin  && (
                                    <TabPanel header="Messaging">
                                        <Messaging />
                                    </TabPanel>
                                )}
                            </TabView>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
